import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useAbExperiment } from 'utils/useAbExperiment'
import { IAppState } from 'infra/AppState'
import { SCREEN_NAME, TABS, TabsDetails } from 'pages/NewDashboard/hooks/constants'

const useTabs = (): { topTabs: TABS; bottomTabs: TABS } => {
  const { billingWeb, staffLink, loading } = useAbExperiment()
  const dashboardState = useSelector((app: IAppState) => app.Dashboard)

  const isBrand = !!dashboardState?.merchantProfile?.data?.isBrand
  const loadingBusinessConfig = dashboardState?.businessAccounts.loading

  const { currentBusinessConfig } = useSelector((app: IAppState) => app.Dashboard)
  const visibleScreens = currentBusinessConfig?.visible_screens
    ? currentBusinessConfig?.visible_screens
    : undefined

  const isScreenVisible = useCallback(
    (screenName: string) => {
      if (!visibleScreens) {
        return true
      }

      return screenName.toLowerCase() in visibleScreens
    },
    [visibleScreens, currentBusinessConfig]
  )

  const topTabs = useMemo(() => {
    if (loading || loadingBusinessConfig) {
      return []
    }

    // if (isBrand) {
    //   return [
    //     ...(isScreenVisible(SCREEN_NAME.stats) ? [TabsDetails[SCREEN_NAME.stats]] : []),
    //     ...(isScreenVisible(SCREEN_NAME.ledger) ? [TabsDetails[SCREEN_NAME.ledger]] : [])
    //   ]
    // }

    const tabs: TABS = [
      ...(isScreenVisible(SCREEN_NAME.ledger) ? [TabsDetails[SCREEN_NAME.ledger]] : []),
      // 1-Click Vasooli (bulk WhatsApp reminders) — always on like Android; ledger merchants only
      ...(!staffLink && isScreenVisible(SCREEN_NAME.collection)
        ? [TabsDetails[SCREEN_NAME.collection]]
        : []),
      ...(isScreenVisible(SCREEN_NAME.myPlan) ? [TabsDetails[SCREEN_NAME.myPlan]] : [])
      // ...(isScreenVisible(SCREEN_NAME.approve) ? [TabsDetails[SCREEN_NAME.approve]] : []),
      // ...(isScreenVisible(SCREEN_NAME.supply) ? [TabsDetails[SCREEN_NAME.supply]] : []),
      // ...(isScreenVisible(SCREEN_NAME.collection) ? [TabsDetails[SCREEN_NAME.collection]] : []),
      // ...(isScreenVisible(SCREEN_NAME.summary) ? [TabsDetails[SCREEN_NAME.summary]] : []),
      // ...(isScreenVisible(SCREEN_NAME.reconcile) ? [TabsDetails[SCREEN_NAME.reconcile]] : [])
    ]

    if (staffLink && isScreenVisible(SCREEN_NAME.ledger)) {
      tabs.shift()
      tabs.push(TabsDetails[SCREEN_NAME.ledger])
    }

    // if (billingWeb && isScreenVisible(SCREEN_NAME.billing)) {
    //   tabs.push(TabsDetails[SCREEN_NAME.billing])
    // }

    return tabs
  }, [billingWeb, loading, staffLink, isBrand, loadingBusinessConfig, currentBusinessConfig])

  const bottomTabs: TABS = [
    ...(isScreenVisible(SCREEN_NAME.help) ? [TabsDetails[SCREEN_NAME.help]] : []),
    ...(isScreenVisible(SCREEN_NAME.settings) ? [TabsDetails[SCREEN_NAME.settings]] : [])
  ]

  return {
    topTabs,
    bottomTabs
  }
}

export default useTabs
